(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-page"] && !Shopify.designMode) return;
  try {
    
  if(Shopify.designMode){
      document.addEventListener('shopify:section:load', function(event) {

        if (!customElements.get('stash-subscription-flow')) {
          alert('Please add the custom element to the page');
          return;
        }
        init();
      });
    }

  } catch(e) { console.error(e); }
})();
})();
